const lookup = require('country-code-lookup');

const countryDropdownOptions = getCountryDropdownOptions();

function getCountryDropdownOptions() {
  var options = [];
  for (const country of lookup.countries) {
    options.push({ text: country.country, value: country.iso2 });
  }
  options.sort((a, b) => a.text.localeCompare(b.text));
  options = [
    options.find(country => country.value == 'ZA'),
    options.find(country => country.value == 'GB'),
    ...options.filter(
      country => country.value !== 'ZA' && country.value !== 'GB'
    ),
  ];

  return options;
}

export { countryDropdownOptions };
